export default "__VITE_ASSET__BP5m0cRS__"